<template>
  <v-dialog
      v-model="localDialog"
      width="85%"
      @update:modelValue="updateDialog"
      transition=""
      persistent
      :open-delay="0"
      :close-delay="0"
  >
    <v-card class="bg-grey-lighten-4" :loading="loading" :disabled="loading">
      <template #loader>
        <v-progress-linear
            color="blue-darken-3"
            height="3.5"
            v-if="loading"
            indeterminate
        />
      </template>

      <v-card-title class="text-h6">
        <v-row>
          <v-col cols="10">
            <span>Update Profile</span>
          </v-col>
          <v-col cols="2">
            <v-layout class="justify-end">
              <v-btn
                  color="red"
                  variant="tonal"
                  type="reset"
                  @click="closeDialog"
              >Close</v-btn
              >
            </v-layout>
          </v-col>
        </v-row>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-row no-gutters style="display: flex; align-items: center">
          <v-col cols="12" md="12" class="border-b">
            <v-tabs
                v-model="tab"
                color="primary"
            >
              <v-tab
                  v-for="(assetDetail, idx) in assetRegistrationTabList"
                  :key="idx"
                  :value="assetDetail.value"
                  class="text-subtitle-2 font-weight-semibold">
                <v-icon start>{{ assetDetail.icon }}</v-icon>
                {{ assetDetail.title }}
              </v-tab>
            </v-tabs>
          </v-col>

          <v-col cols="12" md="12">
            <v-window  v-model="tab">
              <profile-update-personal-info
                  :user-personal-info-data="userPersonalInfoData"
              />
              <profile-update-general-info
                  :user-general-info-data="userGeneralInfoData"
              />
              <profile-update-educational-info
                  :user-education-info-data="userEducationInfoData"
              />
              <profile-update-address-info
                  :user-address-info-data="userAddressInfoData"
              />
              <profile-update-experience-info
                  :user-experience-info-data="userExperienceInfoData"
                  :employee-id="mainId"
              />
              <profile-update-other-info
                  :user-others-info-data="userOthersInfoData"
                  :employee-id="mainId"
              />
            </v-window>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {toast} from "vue3-toastify";
import { fileServerUrl } from "@/store/api";
import UserDetailsGeneralInfoDetails from "@/components/module/administration/userManagement/userDetailsGeneralInfoDetails.vue";
import UserDetailsPersonalInfoDetails from "@/components/module/administration/userManagement/userDetailsPersonalInfoDetails.vue";
import UserDetailsAddressInfoDetails from "@/components/module/administration/userManagement/userDetailsAddressInfoDetails.vue";
import UserDetailsExperienceInfoDetails from "@/components/module/administration/userManagement/userDetailsExperienceInfoDetails.vue";
import UserDetailsOtherInfoDetails from "@/components/module/administration/userManagement/userDetailsOtherInfoDetails.vue";
import ProfileUpdatePersonalInfo from "@/components/module/administration/userManagement/profileUpdatePersonalInfo.vue";
import ProfileUpdateGeneralInfo from "@/components/module/administration/userManagement/profileUpdateGeneralInfo.vue";
import ProfileUpdateEducationalInfo from "@/components/module/administration/userManagement/profileUpdateEducationalInfo.vue";
import ProfileUpdateAddressInfo from "@/components/module/administration/userManagement/profileUpdateAddressInfo.vue";
import ProfileUpdateExperienceInfo from "@/components/module/administration/userManagement/profileUpdateExperienceInfo.vue";
import ProfileUpdateOtherInfo from "@/components/module/administration/userManagement/profileUpdateOtherInfo.vue";

export default {
  name: "ProfileUpdateDialog",
  components: {
    ProfileUpdateEducationalInfo,
    ProfileUpdateAddressInfo,
    ProfileUpdateExperienceInfo,
    ProfileUpdateOtherInfo,
    ProfileUpdateGeneralInfo,
    ProfileUpdatePersonalInfo,
    UserDetailsGeneralInfoDetails,
    UserDetailsPersonalInfoDetails,
    UserDetailsAddressInfoDetails,
    UserDetailsExperienceInfoDetails,
    UserDetailsOtherInfoDetails,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      tab :('details'),
      mainId: null,

      userPersonalInfoData : null,
      userGeneralInfoData : null,
      userSettingsInfoData: null,
      userAddressInfoData: null,
      userOthersInfoData: null,
      userEducationInfoData : [],
      userExperienceInfoData: [],

      fileServerUrl,
      localDialog: this.dialog,
      errorMessages: "",
      preview: "/src/assets/no_preview.jpeg",
      loading: false,
      assetRegistrationTabList: [
        { title: "Personal", icon: "mdi-shield-account", value: "personal" },
        { title: "Genaral", icon: "mdi-puzzle", value: "general" },
        { title: "Education", icon: "mdi-school", value: "educations" },
        { title: "Address", icon: "mdi-map-marker-outline", value: "address" },
        { title: "Experience", icon: "mdi-account-box", value: "experience" },
        { title: "Others", icon: "mdi-plus-box", value: "others" },
      ],
    };
  },
  computed: {},
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);

      if (!val) {
        this.$emit("update:data", null);
      }
    },
    data: {
      async handler(newData) {
        this.mainId = newData;
        this.loading = true;
        try {
          await Promise.all([
            this.$store.dispatch('getHrmBloodGroupList'),
            this.$store.dispatch('getHrmMaritalStatusList'),
            this.$store.dispatch('getHrmReligionList'),
            this.$store.dispatch('getHrmGenderList'),
          ]);
        } catch (error) {
          toast.error(error.response?.data?.message || 'Failed to load dropdown data');
        } finally {
          this.$store.dispatch("getEmployeeDetails", this.mainId).then((response)=> {
            this.userPersonalInfoData = response.data?.data;
            this.profileLoading = false;
            this.loading = false;
          })
        }
      },
    },

    tab(newVal, oldVal) {
      if(newVal === 'personal') {
        this.loading = true;
        try {
          Promise.all([
            this.$store.dispatch('getHrmBloodGroupList'),
            this.$store.dispatch('getHrmMaritalStatusList'),
            this.$store.dispatch('getHrmReligionList'),
            this.$store.dispatch('getHrmGenderList'),
          ]);
        } catch (error) {
          toast.error(error.response?.data?.message || 'Failed to load dropdown data');
        } finally {
          this.$store.dispatch("getEmployeeDetails", this.mainId).then((response)=> {
            this.userPersonalInfoData = response.data?.data;
            this.profileLoading = false;
            this.loading = false;
          })
        }
      }else if(newVal === 'general') {
        this.loading = true,
            this.$store.dispatch("getEmployeeGeneralInfo", this.mainId)
                .then((response) => {
                  this.userGeneralInfoData = response?.data?.data;
                }).finally(() => {
              this.loading= false
            })
      } else if(newVal === 'address') {
        this.loading = true,
            this.$store.dispatch("addressInfo/fetchAddressInfoByEmployee", this.mainId)
                .then((response) => {
                  this.userAddressInfoData = response?.data;
                }).finally(() => {
              this.loading= false
            })
      } else if(newVal === 'settings-info') {
        this.loading = true,
            this.$store.dispatch("settingsInfo/getSettingsInfoByEmployee", this.mainId)
                .then((response) => {
                  this.userSettingsInfoData = response?.data?.data;
                }).finally(() => {
              this.loading= false
            })
      }else if(newVal === 'educations') {
        this.loading = true,
            this.$store.dispatch("educationalInfo/getEducationalInfoByEmployee", this.mainId)
                .then((response) => {
                  this.userEducationInfoData = response?.data || [];
                }).finally(() => {
              this.loading= false
            })
      }else if(newVal === 'experience') {
        this.loading = true,
            this.$store.dispatch("previousEmploymentInfo/fetchPreviousEmploymentInfoByEmployee", this.mainId)
                .then((response) => {
                  this.userExperienceInfoData = response?.data || [];
                }).finally(() => {
              this.loading= false
            })
      }else if(newVal === 'others') {
        this.loading = true,
            this.$store.dispatch("otherInfo/getOtherInfoByEmployee", this.mainId)
                .then((response) => {
                  this.userOthersInfoData = response?.data?.data;
                }).finally(() => {
              this.loading= false
            })
      }
    },
  },
  created() { },
  methods: {
    clearImage() {
      this.preview = "/src/assets/no_preview.jpeg";
    },
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.localDialog = false;
      this.tab = 'personal';
      this.$emit("update:data", null);
    }
  },
  setup(props, { emit }) {},
  mounted() {},
};
</script>
